module.exports = __webpack_public_path__ + "static/media/Picture11.b74b5d03.jpg";